/** Match the payment API: round the 3.7% fee, then round 10% VAT on that fee. */
export function calcPaymentAmounts(amount: number) {
  const principal = Number(amount || 0);
  if (!Number.isFinite(principal) || principal <= 0) return { fee: 0, vat: 0, total: 0 };
  const fee = Math.round(principal * 0.037);
  const vat = Math.round(fee * 0.1);
  return { fee, vat, total: principal + fee + vat };
}
